import { useState, createContext, useMemo } from 'react';

export const AdminContext = createContext({
  user: localStorage.getItem('admin'),
  setUser: () => {

  },
});

export function AdminContextProvider({ children, serverCurrentTime }) {
  const [state, setState] = useState(JSON.parse(localStorage.getItem('admin')));
  const [accessToken, setAccessToken] = useState(JSON.parse(localStorage.getItem('adminAccessToken')));

  const setUser = async (user, token) => {
    setState(user);
    localStorage.setItem('admin', JSON.stringify(user));
    localStorage.setItem('adminAccessToken', JSON.stringify(token));
  };

  const resetUser = () => {
    setState(null);
    localStorage.removeItem('admin');
    localStorage.removeItem('adminAccessToken');
    setAccessToken(null);
  };

  const hasRole = (roles) => {
    const user = JSON.parse(localStorage.getItem('admin'));
    const userRole = user?.role_id || null;
    return roles.some((r) => r === userRole?.name);
  };

  const values = useMemo(() => ({
    user: state,
    setUser,
    accessToken,
    setAccessToken,
    resetUser,
    hasRole,
    serverCurrentTime,
  }), [
    state,
    accessToken,
  ]);

  return (
    <AdminContext.Provider value={values}>
      {children}
    </AdminContext.Provider>
  );
}
